/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
	cellContent,
	row,
	rowIndex,
	{ updateReconcile, reconcileStatus, history }
) => (
	<>

		{/* {reconcileStatus === "APPROVED" && ( */}
		<OverlayTrigger
			overlay={<Tooltip id="products-edit-tooltip">Lihat Detail Donasi</Tooltip>}
		>
			<a
				className="btn btn-primary mr-2"
				onClick={() => {
					history.push(`/donasi/${row.uuid}/detail`)
				}}

			>{row.id}
				Detail Donasi
			</a>
		</OverlayTrigger>
		{/* )} */}
		{reconcileStatus !== "APPROVED" && (
			<OverlayTrigger
				overlay={<Tooltip id="products-edit-tooltip">Lakukan Konfirmasi</Tooltip>}
			>
				<a
					className="btn btn-warning"
					onClick={() => {
						if (window.confirm(`Memilih ${row.donation_hid} untuk konfirmasi?`)) {
							updateReconcile(row);
						}
					}}

				>{row.id}
					Konfirmasi Donasi
				</a>
			</OverlayTrigger>
		)}

	</>
);
